import "./assets/scss/global.scss";
import Routes from "./routes/index";

export default Routes;
